/**
 * Represents the data structure for UI elements in an option form, used to map and configure
 * specific properties of individual form components.
 * It contains additional information which is not stored on the option itself, but in
 * the ui inputs table.
 */
export class OptionFormUiElementsData {
  // common information about which field need to be mapped
  // e.g. subcategory: BINDARY
  subcategory: string | undefined;
  // e.g. inputName: Pack
  inputName: string | undefined;
  // when more options are part of one select box, this indicates which is the default
  isDefault: boolean;
  // when the option has an option value, this is the default value for it
  defaultValue?: string | undefined;
  // when more options are part of one select box, this indicates the order
  sortOrder: number;
  // when the input field is dependent on other fields in the same subcategory,
  // the following fields can be set
  dependsOnField?: string | undefined;
  dependsOnValue?: string | undefined;

  // only for option type cartons
  defaultCartonValue?: string | undefined

  constructor() {
    this.isDefault = false;
    this.sortOrder = 0;
    this.dependsOnField = undefined;
    this.dependsOnValue = undefined;
    this.defaultCartonValue = undefined;
  }
}
